import { Grid } from '@mui/material';
import { LocalAirport } from '@mui/icons-material';
import styled from '@emotion/styled';
import { theme } from 'config';

export const FlightsWrapper = styled(Grid)({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
});

export const PlaneIcon = styled(LocalAirport)({
  position: 'absolute',
  top: '50%',
  left: 'calc(50% - 24px)',
  transform: 'rotate(90deg) translate(-50%, -50%)',

  [theme.breakpoints.down('md')]: {
    top: 'calc(50% - 10px)',
    transform: 'rotate(180deg) translateX(-50%)',
  },
});
